import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon, ZoomInIcon, XIcon } from 'lucide-react';
import { useBackNavigation } from '../hooks/useBackNavigation';
export function Academic() {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const goBack = useBackNavigation('/art');
  const artworks = [{
    image: 'https://storage.yandexcloud.net/maria-images/images/art/20231005_055120%20(1).jpg',
    year: '2018',
    materials: 'Paper, watercolour, pencil',
    description: 'Aleksandro-Nevsky Lavra'
  }, {
    image: 'https://storage.yandexcloud.net/maria-images/images/art/20231005_055134.jpg',
    year: '2018',
    materials: 'Paper, watercolour',
    description: 'Plein-Air'
  }, {
    image: 'https://storage.yandexcloud.net/maria-images/images/art/20231010_002435%20(1).jpg',
    year: '2017',
    materials: 'Paper, watercolour, pencil',
    description: 'Still Life'
  }, {
    image: 'https://storage.yandexcloud.net/maria-images/images/art/art1.jpg',
    year: '2017',
    materials: 'Paper, pencil',
    description: 'Venus'
  }, {
    image: 'https://storage.yandexcloud.net/maria-images/images/art/art2.jpg',
    year: '2017',
    materials: 'Paper, pencil',
    description: 'Perspective Study'
  }, {
    image: 'https://storage.yandexcloud.net/maria-images/images/art/20231004_013305%20(1).jpg',
    year: '2016',
    materials: 'Paper, pencil',
    description: 'Artist Study'
  }, {
    image: 'https://storage.yandexcloud.net/maria-images/images/art/20231004_013900%20(1).jpg',
    year: '2016',
    materials: 'Paper, crayon',
    description: 'Nude Study'
  }, {
    image: 'https://storage.yandexcloud.net/maria-images/images/art/20231004_013942.jpg',
    year: '2016',
    materials: 'Paper, crayon, graphite',
    description: 'Nude Study'
  }];
  return <div className="w-full min-h-screen bg-white" data-id="element-40">
      {/* Image Modal */}
      {selectedImage && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4" onClick={() => setSelectedImage(null)} data-id="element-41">
          <button onClick={() => setSelectedImage(null)} className="absolute top-4 right-4 text-white hover:text-cyan-400 transition-colors" data-id="element-42">
            <XIcon className="w-8 h-8" data-id="element-43" />
          </button>
          <motion.img initial={{
        scale: 0.9
      }} animate={{
        scale: 1
      }} src={selectedImage} alt="Enlarged view" className="max-w-full max-h-full object-contain" data-id="element-44" />
        </motion.div>}
      {/* Header */}
      <header className="py-8 px-6 bg-white border-b border-stone-200 sticky top-0 z-40" data-id="element-45">
        <div className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-46">
          <button onClick={goBack} className="inline-flex items-center gap-2 text-stone-600 hover:text-stone-900 transition-colors" data-id="element-47">
            <ArrowLeftIcon className="w-5 h-5" data-id="element-48" />
            <span className="font-light" data-id="element-49">Back</span>
          </button>
          <h1 className="text-2xl font-light text-stone-900" data-id="element-50">Maria Elina</h1>
        </div>
      </header>
      {/* Hero Section */}
      <section className="py-20 px-6 bg-gradient-to-br from-stone-50 via-cyan-50/30 to-stone-50" data-id="element-51">
        <div className="max-w-5xl mx-auto" data-id="element-52">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-53">
            <p className="text-cyan-600 font-light tracking-wide uppercase mb-4" data-id="element-54">
              Classical Techniques
            </p>
            <h1 className="text-4xl md:text-6xl font-light text-stone-900 mb-6" data-id="element-55">
              Academic
            </h1>
            <p className="text-xl text-stone-600 font-light mb-8" data-id="element-56">
              Traditional studies in watercolor, oil, and mixed media, honoring
              classical approaches to composition and form
            </p>
          </motion.div>
        </div>
      </section>
      {/* Gallery Grid */}
      <section className="py-20 px-6 bg-white" data-id="element-57">
        <div className="max-w-7xl mx-auto" data-id="element-58">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-59">
            {artworks.map((artwork, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} className="group" data-id="element-60">
                <div className="relative overflow-hidden rounded-xl shadow-lg mb-4 aspect-square cursor-pointer" onClick={() => setSelectedImage(artwork.image)} data-id="element-61">
                  <img src={artwork.image} alt={`Artwork ${index + 1}`} className="w-full h-full object-cover" data-id="element-62" />
                  <div className="absolute inset-0 bg-stone-900/0 group-hover:bg-stone-900/10 transition-colors duration-300 flex items-center justify-center" data-id="element-63">
                    <ZoomInIcon className="w-8 h-8 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-64" />
                  </div>
                </div>
                <div className="space-y-2" data-id="element-65">
                  <p className="text-sm text-cyan-600 font-light" data-id="element-66">
                    {artwork.year} • {artwork.materials}
                  </p>
                  <p className="text-stone-600 font-light text-sm leading-relaxed" data-id="element-67">
                    {artwork.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>
    </div>;
}